module.exports = __webpack_public_path__ + "img/chinesecompany09.5be2edae.png";